import React, { useEffect } from 'react'
import { View } from 'react-native'
import { useDispatch } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import tw from 'tailwind-rn'

import { RootStackParamList } from '../../navigators/AppNavigator'
import ActionCreators from '../../store/actions'
import SignUpForm, { SignUpFirstStepValues } from './SignUpForm'
import styles from './styles'
import { HGText, HGView } from '../../components/HGUI'
import HansGretelLogo from './HansGretelLogo'

type Props = {
  navigation: StackNavigationProp<RootStackParamList, 'SignUp'>
}

const SignUpScreen = (props: Props) => {
  const { navigation } = props
  const dispatch = useDispatch()

  const handleFormSubmit = async (
    { memberCode }: SignUpFirstStepValues,
    setSubmitting: (value: boolean) => void,
    setFieldError: (field: string, message: string) => void
  ) => {
    const registrationCode = memberCode
    if (!registrationCode.length) return
    setSubmitting(true)

    try {
      await dispatch(
        ActionCreators.validateRegistrationCode({ registrationCode })
      )
      navigation.navigate('SignUpSecond', { registrationCode })
    } catch (reason) {
      setFieldError(
        'memberCode',
        'Dieser Weiterbildungscode scheint nicht gültig zu sein. Bitte überprüfen Sie Ihren Code.'
      )
      // dispatch(
      //   ActionCreators.handleError({
      //     code: 'auth/registration-code-invalid',
      //   })
      // )
    } finally {
      setSubmitting(false)
    }
  }

  useEffect(() => {
    if (!navigation.canGoBack()) {
      navigation.reset({
        index: 1,
        routes: [{ name: 'Onboarding' }, { name: 'SignUp' }],
      })
    }
  }, [])

  return (
    <HGView style={styles.centerWrap}>
      <View style={tw('mb-8')}>
        <HansGretelLogo />
      </View>

      <View style={styles.centerWrapInner}>
        <HGText style={styles.helpText}>
          Bitte geben Sie zur Authentizifierung Ihren Fortbildungscode der
          Sächsischen Landesärztekammer an.
        </HGText>

        <SignUpForm onSubmit={handleFormSubmit} />
      </View>
    </HGView>
  )
}

export default SignUpScreen
